import { Environment } from './environment';

let url: string;

if (Environment.isProduction()) {
    url = 'https://solaris-backend-development.replit.app/';    
} else {
    url = "https://a5d105b2-054e-4f6d-a7c2-5b0f27f4046e-00-33bmfpe9h80v4.riker.repl.co/";
}

export const getApiUrl = () => url;
